import { EnumRichiestaDTOStatoOneri } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaDTOStatoOneri.ts';
import { EnumRichiestaDTOStatoPreventivi } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaDTOStatoPreventivi.ts';

export class SubmissionBurdenLogic {
  /**
   * Verifica se ci sono degli oneri pendenti non facoltativi ancora
   * da pagare.
   */
  static hasPendingPayments(
    burdenState: EnumRichiestaDTOStatoOneri | null | undefined,
  ) {
    if (!burdenState) return false;
    return burdenState === EnumRichiestaDTOStatoOneri.DA_PAGARE;
  }

  /**
   * Ritorna vero se la richiesta ha degli oneri (facoltativi o meno)
   */
  static hasBurdens(
    burdenState: EnumRichiestaDTOStatoOneri | null | undefined,
  ): burdenState is EnumRichiestaDTOStatoOneri {
    if (!burdenState) return false;
    return burdenState !== EnumRichiestaDTOStatoOneri.NESSUNO;
  }

  static hasAfterSendPayments(
    burdenState: EnumRichiestaDTOStatoOneri | null | undefined,
  ) {
    if (!burdenState) return false;

    return burdenState === EnumRichiestaDTOStatoOneri.DA_PAGARE_FACOLTATIVO;
  }

  /**
   * Se `true`, mostra la sezione dei pagamenti (nel menu laterale dei moduli e come tab nelle richieste inviate)
   */
  static showPayments(
    burdenState: EnumRichiestaDTOStatoOneri | null | undefined,
    quoteState: EnumRichiestaDTOStatoPreventivi | null | undefined,
    hidePayment = false,
  ) {
    // Se viene richiesto di nasconderli, non sono visibili
    if (hidePayment) {
      return false;
    }

    // se ci sono oneri, mostro i pagamenti
    if (SubmissionBurdenLogic.hasBurdens(burdenState)) {
      return true;
    }

    // Se ci sono dei preventivi, mostro i pagamenti
    if (quoteState !== EnumRichiestaDTOStatoPreventivi.NESSUNO) {
      return true;
    }

    return false;
  }

  static hasPendingQuotes(
    quoteState: EnumRichiestaDTOStatoPreventivi | null | undefined,
  ) {
    return (
      quoteState === EnumRichiestaDTOStatoPreventivi.DA_ACCETTARE ||
      quoteState === EnumRichiestaDTOStatoPreventivi.DA_PAGARE
    );
  }
}
